import { componentLabel } from '../../core/registry/componentLabels';

export const blockLabel = (node, t, rootId) => {
  if (!node) return '';
  if (node.id === rootId) return t('experience.design.pageLayout');
  return componentLabel(node.type, t);
};

export const slotLabel = (slot, t) => {
  const column = /^col-(\d+)$/.exec(slot);
  if (column) return t('experience.design.column', { number: column[1] });
  if (slot === 'items') return t('experience.design.content');
  return slot.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/[-_]/g, ' ');
};

export const childSlots = (node) => Object.entries(node?.slots || {})
  .filter(([, ids]) => Array.isArray(ids))
  .sort(([a], [b]) => a.localeCompare(b, undefined, { numeric: true }));

/** Ordered, cycle-safe outline metadata. Config remains a flat graph. */
export const outlineRows = (canvas, t, includeInternal = false) => {
  const byId = new Map((canvas?.nodes || []).map(node => [node.id, node]));
  const seen = new Set();
  const rows = [];
  const walk = (id, depth, parents, location) => {
    const node = byId.get(id);
    if (!node || seen.has(id)) return;
    seen.add(id);
    const slots = childSlots(node);
    const internal = node.type === 'columns' && !includeInternal;
    if (!internal) rows.push({ node, depth, parents, location, container: slots.length > 0 });
    slots.forEach(([slot, ids]) => ids.forEach(child => walk(
      child, depth + (internal ? 0 : 1), internal ? parents : [...parents, id],
      !internal && slots.length > 1 ? slotLabel(slot, t) : location,
    )));
  };
  if (canvas?.root) walk(canvas.root, 0, [], '');
  // Retain access to unusual legacy nodes, even if not linked from the root.
  (canvas?.nodes || []).forEach(node => {
    if (!seen.has(node.id)) walk(node.id, 0, [], t('experience.design.unplaced'));
  });
  return rows;
};
